import type { TPermission } from '@lib/types/generated/TPermission';
import type { TResourceStatus } from '@lib/types/generated/TResourceStatus';
import type { TPermissionData } from '@models/authorization/TPermissionData';

export type PermissionCheckContext = {
  isOnCall: boolean;
  resourceStatus?: TResourceStatus;
};

export function doesUserHavePermission(
  v2: TPermissionData,
  key: TPermission,
  context: PermissionCheckContext,
): boolean {
  if (!v2.permissions.includes(key)) {
    return false;
  }

  const grants = v2.roles.flatMap((role) => role.permissions).filter((p) => p.key === key);

  if (grants.length === 0) {
    return true;
  }

  // If ANY grant passes all its conditions, allow.
  return grants.some((grant) => {
    const conditions = grant.conditions;

    if (conditions == null) {
      return true;
    }

    if (conditions.onCall === true && !context.isOnCall) {
      return false;
    }

    if (
      conditions.resourceStatus != null &&
      conditions.resourceStatus.length > 0 &&
      (context.resourceStatus == null ||
        !conditions.resourceStatus.includes(context.resourceStatus))
    ) {
      return false;
    }

    return true;
  });
}
